module.exports = __webpack_public_path__ + "img/2_40.e4b3b4c3.png";